import { BankAccountStoreState, PaymentProviderBankDetails } from '@/interfaces/bank-account';

export function setBankAccountDetails(
  state: BankAccountStoreState,
  details: PaymentProviderBankDetails
) {
  state.bank_details = details;
}
